import React from 'react';
import {
  FiUsers,
  FiFileText,
  FiDollarSign,
  FiActivity,
  FiAlertTriangle,
  FiCheckCircle,
  FiClock,
  FiClipboard,
  FiTrendingUp,
  FiSettings,
  FiDatabase,
  FiShield,
  FiGlobe,
} from 'react-icons/fi';
import './AdminDashboard.css';

const AdminDashboard: React.FC = () => {
  return (
    <div className="admin-dashboard">
      {/* Admin Stats */}
      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <div className="admin-stat-icon blue"><FiUsers /></div>
          <div className="admin-stat-info">
            <span className="admin-stat-value">1,284</span>
            <span className="admin-stat-label">Total Users</span>
            <span className="admin-stat-change positive">+12% this month</span>
          </div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-icon green"><FiFileText /></div>
          <div className="admin-stat-info">
            <span className="admin-stat-value">48,392</span>
            <span className="admin-stat-label">Documents Managed</span>
            <span className="admin-stat-change positive">+340 today</span>
          </div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-icon orange"><FiDollarSign /></div>
          <div className="admin-stat-info">
            <span className="admin-stat-value">$892K</span>
            <span className="admin-stat-label">Revenue Tracked</span>
            <span className="admin-stat-change positive">+8% this month</span>
          </div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-icon purple"><FiActivity /></div>
          <div className="admin-stat-info">
            <span className="admin-stat-value">99.7%</span>
            <span className="admin-stat-label">System Uptime</span>
            <span className="admin-stat-change neutral">Last 30 days</span>
          </div>
        </div>
      </div>

      {/* Main Admin Grid */}
      <div className="admin-grid">
        {/* Client Overview */}
        <div className="admin-card wide">
          <div className="admin-card-header">
            <h3><FiUsers /> Client Management</h3>
            <div className="header-actions">
              <button className="btn-action">Add Client</button>
              <a href="/admin/users" className="card-link">Manage All</a>
            </div>
          </div>
          <div className="admin-card-body">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Client</th>
                  <th>Plan</th>
                  <th>Documents</th>
                  <th>Status</th>
                  <th>Last Active</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="client-info">
                      <div className="client-avatar">AC</div>
                      <div>
                        <span className="client-name">Acme Corporation</span>
                        <span className="client-email">admin@acme.com</span>
                      </div>
                    </div>
                  </td>
                  <td><span className="plan-badge pro">Professional</span></td>
                  <td>342</td>
                  <td><span className="status-badge active"><FiCheckCircle /> Active</span></td>
                  <td>2 min ago</td>
                </tr>
                <tr>
                  <td>
                    <div className="client-info">
                      <div className="client-avatar">WS</div>
                      <div>
                        <span className="client-name">Widget Solutions</span>
                        <span className="client-email">info@widgets.com</span>
                      </div>
                    </div>
                  </td>
                  <td><span className="plan-badge starter">Starter</span></td>
                  <td>89</td>
                  <td><span className="status-badge active"><FiCheckCircle /> Active</span></td>
                  <td>1 hour ago</td>
                </tr>
                <tr>
                  <td>
                    <div className="client-info">
                      <div className="client-avatar">TG</div>
                      <div>
                        <span className="client-name">TechGlobal Inc</span>
                        <span className="client-email">hello@techglobal.io</span>
                      </div>
                    </div>
                  </td>
                  <td><span className="plan-badge enterprise">Enterprise</span></td>
                  <td>1,204</td>
                  <td><span className="status-badge pending"><FiClock /> Pending</span></td>
                  <td>3 days ago</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Tax Filing Status */}
        <div className="admin-card">
          <div className="admin-card-header">
            <h3><FiClipboard /> Tax Filing Status</h3>
          </div>
          <div className="admin-card-body">
            <div className="filing-stats">
              <div className="filing-stat">
                <div className="filing-number">127</div>
                <div className="filing-label">Completed</div>
                <div className="filing-bar">
                  <div className="filing-progress green" style={{ width: '70%' }}></div>
                </div>
              </div>
              <div className="filing-stat">
                <div className="filing-number">34</div>
                <div className="filing-label">In Progress</div>
                <div className="filing-bar">
                  <div className="filing-progress blue" style={{ width: '19%' }}></div>
                </div>
              </div>
              <div className="filing-stat">
                <div className="filing-number">18</div>
                <div className="filing-label">Pending Review</div>
                <div className="filing-bar">
                  <div className="filing-progress orange" style={{ width: '10%' }}></div>
                </div>
              </div>
              <div className="filing-stat">
                <div className="filing-number">2</div>
                <div className="filing-label">Overdue</div>
                <div className="filing-bar">
                  <div className="filing-progress red" style={{ width: '1%' }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* System Alerts */}
        <div className="admin-card">
          <div className="admin-card-header">
            <h3><FiAlertTriangle /> System Alerts</h3>
          </div>
          <div className="admin-card-body">
            <div className="alert-list">
              <div className="alert-item warning">
                <FiAlertTriangle />
                <div className="alert-info">
                  <span className="alert-title">Storage usage at 78%</span>
                  <span className="alert-time">10 min ago</span>
                </div>
              </div>
              <div className="alert-item info">
                <FiShield />
                <div className="alert-info">
                  <span className="alert-title">3 new user signups pending approval</span>
                  <span className="alert-time">1 hour ago</span>
                </div>
              </div>
              <div className="alert-item success">
                <FiCheckCircle />
                <div className="alert-info">
                  <span className="alert-title">Backup completed successfully</span>
                  <span className="alert-time">3 hours ago</span>
                </div>
              </div>
              <div className="alert-item info">
                <FiGlobe />
                <div className="alert-info">
                  <span className="alert-title">New region: Ontario, CA added</span>
                  <span className="alert-time">Yesterday</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Admin Quick Actions */}
        <div className="admin-card wide">
          <div className="admin-card-header">
            <h3><FiSettings /> Administration</h3>
          </div>
          <div className="admin-card-body">
            <div className="admin-actions-grid">
              <button className="admin-action-btn">
                <FiUsers />
                <span>User Management</span>
                <small>Add, edit, remove users</small>
              </button>
              <button className="admin-action-btn">
                <FiShield />
                <span>Roles & Permissions</span>
                <small>Configure access levels</small>
              </button>
              <button className="admin-action-btn">
                <FiGlobe />
                <span>Regions & Tax Rules</span>
                <small>Multi-jurisdiction setup</small>
              </button>
              <button className="admin-action-btn">
                <FiDatabase />
                <span>Data & Backups</span>
                <small>Manage system data</small>
              </button>
              <button className="admin-action-btn">
                <FiTrendingUp />
                <span>Reports & Analytics</span>
                <small>System-wide reports</small>
              </button>
              <button className="admin-action-btn">
                <FiActivity />
                <span>Audit Logs</span>
                <small>Track all activities</small>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
